/* 🤖 this file was generated by svg-to-ts */
export const matIconPlaylistAddCheck: {
  name: 'playlist-add-check';
  data: string;
} = {
  name: 'playlist-add-check',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M3 10h11v2H3zm0-4h11v2H3zm0 8h7v2H3zm17.59-2.07-4.25 4.24-2.12-2.12-1.41 1.41L16.34 19 22 13.34z"/></svg>`
};
